const useStyles = theme => ({
    dialogContent:{
        margin: "auto"
    },
    colorBox: {
		width: '30px', 
        height: '30px', 
        marginRight: '14px', 
        marginTop: '14px', 
        border: '1px solid #ddd', 
        cursor: 'pointer'
	},
    popOverDiv:{
        height:"50vh", 
        display:"flex", 
        justifyContent:"center", 
        alignItems:"center", 
        overflow:"auto"
    },
    colorPickerDiv: {
        position:"relative"
	},
});

export default useStyles;